import { render, staticRenderFns } from "./teacherIndex.vue?vue&type=template&id=4bf0e6b0&"
import script from "./teacherIndex.vue?vue&type=script&lang=js&"
export * from "./teacherIndex.vue?vue&type=script&lang=js&"
import style0 from "./teacherIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports